import { IProblemGenerator } from "./sharedTypes";

type OperandOption = {
    min?: number;
    max?: number;
}
export type MultiplicationOptions = {
    operand1?: OperandOption;
    operand2?: OperandOption;
    progression?: boolean;
    progressionRate?: number;
}

const DEFAULT_MAX_OPERAND = 9;

export default class MultiplicationProblemGenerator implements IProblemGenerator {
    private options?: MultiplicationOptions
    private lastOperandIncreased: 1 | 2;
    private currentStreak: number;

    constructor(options: MultiplicationOptions) {
        this.currentStreak = 0;
        this.lastOperandIncreased = 1;
        this.options = options;
    }
    getNext() {
        const op1Range = (this?.options?.operand1?.max??DEFAULT_MAX_OPERAND) - (this?.options?.operand1?.min??0)
        const op2Range = (this?.options?.operand2?.max??DEFAULT_MAX_OPERAND) - (this?.options?.operand2?.min??0)
        const op1 = Math.round(Math.random() * op1Range + (this?.options?.operand1?.min??0))
        const op2 = Math.round(Math.random() * op2Range + (this?.options?.operand2?.min??0))

        return {
            generator: "Multiplication",
            display: Math.random() > 0.5 ? `${op1} x ${op2}` : `${op2} x ${op1}`, // allow swapping of operands
            userAnswer: undefined,
            correctAnswer: op1*op2
        }
    }
    reportResult(wasCorrect: boolean, userAnswer: number) {
        if (this.options?.progression === true) {

            if (wasCorrect) {
                this.currentStreak += 1;
                console.log(`Current Streak: ${this.currentStreak}`);
            } else {
                this.currentStreak = 0;
            }

            if (this.currentStreak >= (this.options?.progressionRate ?? 10)) {
                console.log(`Increasing multiplication difficulty`)
                if (this.lastOperandIncreased === 2) {
                    if (this.options?.operand1?.max)
                        this.options.operand1.max = this.options?.operand1?.max + 1;
                    if (this.options?.operand1?.min)
                        this.options.operand1.min += 1;
                } else {
                    if (this.options?.operand2?.max)
                        this.options.operand2.max = this.options?.operand2?.max + 1;
                    if (this.options?.operand2?.min)
                        this.options.operand2.min += 1;
                }

                this.lastOperandIncreased = this.lastOperandIncreased === 2 ? 1 : 2;

                this.currentStreak = 0;
            }
        }
    }
}